import { differenceInDays } from '#src/app/shared/utils/dates';

import type { StarterDashboardV2RootPageDataQuery } from '../rootPageData.graphql';

type Petition = NonNullable<StarterDashboardV2RootPageDataQuery['petition']>;
export function getPetitionDaysAfterPublish(petition: Petition) {
	const now = new Date();

	return differenceInDays(now, new Date(petition.publishedAt ?? 0));
}
